import AxiosClient from "./axiosClient";

const ZaloApi = {
  getZaloList: (params) => {
    const url = "/zalo/all";
    return AxiosClient.get(url, {
      params,
      baseURL: process.env.REACT_APP_BASE_URL_V3,
    });
  },

  deleteIntegrate: (params) => {
    const url = "/zalo/deintegrate";
    return AxiosClient.post(
      url,
      {
        ...params,
      },
      {
        baseURL: process.env.REACT_APP_BASE_URL_V3,
      },
    );
  },
  integrate: (params) => {
    const url = "/zalo/integrate";
    return AxiosClient.get(url, {
      params,
      baseURL: process.env.REACT_APP_BASE_URL_V3,
    });
  },
};

export default ZaloApi;
